module.exports = __webpack_public_path__ + "img/home1-1.8b269567.jpg";